export default class Member
{
  constructor(roles, descriptions, name, photo) 
  {
    // {} instead of array to support stringify
    this.roles = roles;

    this.name = name;
    this.photo = photo;
  }    

  isValid()
  {
    var result = true;

    for (const [key, value] of Object.entries(this.roles)) { if(!value) { result = false; break; }; } // Roles

    if(result) result = this.name && this.photo;
    
    return result;
  }
}